import * as React from 'react';
import PropTypes from 'prop-types';
var SvgSportsHikeNormalXsmall = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15.86 10a2.08 2.08 0 00-1.59-1.53l-2.38-.4-3-2.12-.4-3.09A1 1 0 007.5 2a8 8 0 00-3.77 1H1.5a1 1 0 00-1 .93C.45 4.65 0 11 0 11.67 0 12.83 1 14 3 14h2a2 2 0 001.59-1 6 6 0 011.66.39 9.52 9.52 0 003.4.61 5.09 5.09 0 003.81-1.55A2.1 2.1 0 0016 11a3.23 3.23 0 00-.14-1zM4 4a6.92 6.92 0 013.5-1l.43 3H1.36l.14-2zm10.76 7.74A4.08 4.08 0 0111.67 13C9 13 8.33 12 6.33 12c-.46 0-.67 1-1.33 1H3c-1.33 0-2-.67-2-1.33C1 11.3 1.15 9 1.29 7H8.7l2.8 2 2.6.44c.98.17 1.1 1.86.66 2.3z"
  }));
});
SvgSportsHikeNormalXsmall.defaultProps = {
  height: 16,
  width: 16
};
SvgSportsHikeNormalXsmall.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number
};
export default SvgSportsHikeNormalXsmall;